import script from "./ForecastRecoveryStatusIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForecastRecoveryStatusIcon.vue?vue&type=script&lang=ts&setup=true"

import "./ForecastRecoveryStatusIcon.vue?vue&type=style&index=0&id=ff6538ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff6538ea"]])

export default __exports__